import PropTypes from 'prop-types';
import React from 'react';

const NoResultsLeft = ({ className, width, height, ...otherProps }) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 1169 246"
    version="1.1"
    {...otherProps}
  >
    <defs>
      <polygon
        id="path-1"
        points="0 89.7425 5.6034 89.7425 5.6034 95.3465 0 95.3465"
      />
    </defs>
    <g
      id="NO-RESULTS-PAGE"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="1280" transform="translate(-51.000000, -236.000000)">
        <g id="Page-1" transform="translate(50.000000, 235.000000)">
          <g id="Group-139" transform="translate(0.000000, 0.819000)">
            <g id="Group" transform="translate(1.000000, 0.000000)">
              <path
                d="M123.286,127.181 C96.501,127.181 68.372,142.404 54,164.679"
                id="Stroke-4"
                stroke="#729FBE"
              />
              <path
                d="M134.4149,216.1675 L134.4149,243.9035"
                id="Stroke-111"
                stroke="#729FBE"
              />
              <path
                d="M148.2835,230.0357 L120.5465,230.0357"
                id="Stroke-113"
                stroke="#729FBE"
              />
              <path
                d="M139.6424,235.2632 L129.1864,224.8082"
                id="Stroke-115"
                stroke="#729FBE"
              />
              <path
                d="M129.1869,235.2632 L139.6429,224.8082"
                id="Stroke-117"
                stroke="#729FBE"
              />
              <path
                d="M792.9188,218.0845 L792.9188,245.8205"
                id="Stroke-119"
                stroke="#729FBE"
              />
              <path
                d="M806.787,231.9527 L779.05,231.9527"
                id="Stroke-121"
                stroke="#729FBE"
              />
              <path
                d="M798.1464,237.1802 L787.6914,226.7252"
                id="Stroke-123"
                stroke="#729FBE"
              />
              <path
                d="M787.6913,237.1802 L798.1463,226.7252"
                id="Stroke-125"
                stroke="#729FBE"
              />
              <path
                d="M154.4408,119.4048 C154.1638,121.5528 152.1968,123.0698 150.0478,122.7928 C147.8988,122.5148 146.3818,120.5488 146.6598,118.3988 C146.9378,116.2508 148.9038,114.7338 151.0528,115.0108 C153.2018,115.2888 154.7188,117.2558 154.4408,119.4048"
                id="Fill-127"
                fill="#729FBE"
              />
              <path
                d="M934.2928,97.1841 C934.2928,98.7321 933.0378,99.9861 931.4908,99.9861 C929.9428,99.9861 928.6888,98.7321 928.6888,97.1841 C928.6888,95.6371 929.9428,94.3821 931.4908,94.3821 C933.0378,94.3821 934.2928,95.6371 934.2928,97.1841"
                id="Fill-25"
                fill="#729FBE"
              />
              <path
                d="M554.6034,208.6929 C554.6034,210.2399 553.3494,211.4949 551.8014,211.4949 C550.2544,211.4949 548.9994,210.2399 548.9994,208.6929 C548.9994,207.1459 550.2544,205.8909 551.8014,205.8909 C553.3494,205.8909 554.6034,207.1459 554.6034,208.6929"
                id="Fill-27"
                fill="#729FBE"
              />
              <path
                d="M281.6034,216.1675 C281.6034,217.7145 280.3494,218.9695 278.8014,218.9695 C277.2544,218.9695 275.9994,217.7145 275.9994,216.1675 C275.9994,214.6195 277.2544,213.3655 278.8014,213.3655 C280.3494,213.3655 281.6034,214.6195 281.6034,216.1675"
                id="Fill-29"
                fill="#729FBE"
              />
              <path
                d="M195.515,178.3521 C195.515,179.8991 194.261,181.1541 192.714,181.1541 C191.166,181.1541 189.912,179.8991 189.912,178.3521 C189.912,176.8051 191.166,175.5501 192.714,175.5501 C194.261,175.5501 195.515,176.8051 195.515,178.3521"
                id="Fill-31"
                fill="#729FBE"
              />
              <path
                d="M79.8016,6.7427 L103.8016,20.7427"
                id="Stroke-33"
                stroke="#729FBE"
              />
              <path
                d="M79.8016,6.7427 L103.8016,20.7427"
                id="Stroke-35"
                stroke="#729FBE"
              />
              <path
                d="M95.3373,27.1783 L88.2663,0.3083"
                id="Stroke-37"
                stroke="#729FBE"
              />
              <path
                d="M105.2367,10.2076 L78.3667,17.2786"
                id="Stroke-39"
                stroke="#729FBE"
              />
              <path
                d="M84.8016,25.7427 L98.8016,1.7427"
                id="Stroke-41"
                stroke="#729FBE"
              />
              <path
                d="M1155.8651,57.3755 L1152.8641,84.9975"
                id="Stroke-43"
                stroke="#729FBE"
              />
              <path
                d="M1155.8651,57.3755 L1152.8641,84.9975"
                id="Stroke-45"
                stroke="#729FBE"
              />
              <path
                d="M1143.538,79.8911 L1165.191,62.4811"
                id="Stroke-47"
                stroke="#729FBE"
              />
              <path
                d="M1163.0692,82.0132 L1145.6592,60.3602"
                id="Stroke-49"
                stroke="#729FBE"
              />
              <path
                d="M1140.5536,69.6861 L1168.1756,72.6871"
                id="Stroke-51"
                stroke="#729FBE"
              />
              <g id="Clip-23" />
              <path
                d="M5.6034,92.5445 C5.6034,94.0915 4.3494,95.3465 2.8014,95.3465 C1.2544,95.3465 -0.0006,94.0915 -0.0006,92.5445 C-0.0006,90.9975 1.2544,89.7425 2.8014,89.7425 C4.3494,89.7425 5.6034,90.9975 5.6034,92.5445"
                id="Fill-22"
                fill="#729FBE"
                mask="url(#mask-2)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

NoResultsLeft.propTypes = {
  className: PropTypes.string,
  width: PropTypes.node,
  height: PropTypes.node,
};

NoResultsLeft.defaultProps = {
  height: 290,
  width: 335,
};

export default NoResultsLeft;
